"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationService = function () {
  function NotificationService(Notification, $http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NotificationService);
    this.Notification = Notification;
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(NotificationService, [{
    key: "showEnquiryNotification",
    value: function showEnquiryNotification(scope, templateId) {
      this.Notification.info({
        positionY: 'bottom',
        delay: 30 * 1000,
        replaceMessage: false,
        templateUrl: "templates/notification/" + templateId,
        scope: scope
      });
    }
  }, {
    key: "sendFinanceCreatedNotification",
    value: function sendFinanceCreatedNotification(financeId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/notification/notifyfinancecreated/" + financeId));
    }
  }]);
  return NotificationService;
}();

exports.default = NotificationService;


// WEBPACK FOOTER //
// ./client/app/common/services/notificationService.js